module.exports = __webpack_public_path__ + "static/notifications2-da7a38173083604601694c1a03fa3214.png";